import { EventTarget } from 'cc';

export default abstract class Model extends EventTarget {
    /**
     * Method will be invoked after all model are constructed
     */
    public abstract init(): void;
}
